import { useSyncExternalStore } from 'react';
import axios from 'axios';

let flags = {};
const listeners = new Set();

function subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

/**
 * Fetches the current feature flag states and replaces whatever was loaded before.
 * Never rejects; on failure the previously loaded flags are kept.
 */
export async function loadFeatureFlags() {
    try {
        const response = await axios.get('/dashboard/feature-flags');
        flags = Object.fromEntries(response.data.map(flag => [flag.identifier, flag.state]));
        listeners.forEach(listener => listener());
    } catch {
        // The axios interceptor already reports the failure to the user
    }
}

/** Non-hook check for use outside components. Unknown or not-yet-loaded flags are disabled. */
export function isFeatureFlagEnabled(identifier) {
    return flags[identifier] === true;
}

/** Hook that re-renders the component whenever the flags are reloaded. */
export function useFeatureFlag(identifier) {
    return useSyncExternalStore(subscribe, () => isFeatureFlagEnabled(identifier));
}
